module.exports = __webpack_public_path__ + "static/media/rockWallSheetBottom.1437b575.png";